import React from 'react'

import { Field } from 'formik'

import { Button, Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import { KeyEventUtil } from 'utils'

import * as TiposCambioService from 'services/tiposCambio.service'

const TipoCambioFormGroup = ({ iError, iTouched, iMoneda, iFechaEmision, setFieldValue }) => {
  const [mostrarModal, setMostrarModal] = React.useState(false)

  const consultarTipoCambio = React.useCallback(() => {
    const monedaConsulta = iMoneda === MonedasConstant.EUROS ? MonedasConstant.EUROS : MonedasConstant.DOLARES

    TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaEmision, monedaConsulta, 'VENT').then(({ data }) => {
      setFieldValue('tipoCambio', data.tipoCambio || 0)
    })
  }, [iMoneda, iFechaEmision, setFieldValue])

  React.useEffect(() => {
    if (iFechaEmision !== '' && iMoneda !== '') {
      consultarTipoCambio()
    } else {
      setFieldValue('tipoCambio', 0)
    }
  }, [iFechaEmision, iMoneda, consultarTipoCambio, setFieldValue])

  const clickTiposCambio = React.useCallback(() => {
    setMostrarModal(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setMostrarModal(false)
    consultarTipoCambio()
  }, [consultarTipoCambio])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-glosa', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='T/C' htmlFor='input-tipoCambio' md={6} alignRightAt='md' />
        <Col md={6}>
          <Form.InputGroup>
            <Field name='tipoCambio'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  id='input-tipoCambio'
                  disabled
                  isInvalid={iTouched && iError}
                  onKeyDown={onKeyDown}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={clickTiposCambio}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModal && (
        <TipoCambioModal show={mostrarModal} handleClose={handleCloseModal} fechaReferencia={iFechaEmision} />
      )}
    </>
  )
}

export default React.memo(TipoCambioFormGroup)
